{
  "disclosure": "Divulgar",
  "loan-terms": "Términos del préstamo",
  "projected-payments": "Pagos Proyectados",
  "cash-to-close": "Efectivo para cerrar",
  "liability-after-foreclosure": "Responsabilidad después de la ejecución hipotecaria",
  "loan-calculations": "Cálculos de préstamos",
  "if-you-lender": "Si su prestamista ejecuta la ejecución hipotecaria de esta propiedad y la ejecución hipotecaria no cubre el monto del saldo impago de este préstamo",
  "protects-from-unpaid-balance-liability": "Protege de la obligación de saldo impago",
  "dont-protects-from-unpaid-balance-liability": "No protege de la obligación de saldo impago",
  "loan-amount": "Monto del Préstamo",
  "interest-rate": "Tasa de Interés",
  "monthly-principal-interest": "Interés Principal Mensual",
  "prepayment-penalty": "Sanción Por Pago Anticipado",
  "balloon-payment": "Pago Global",
  "can-increase": "Puede aumentar",
  "cannot-increase": "No puede aumentar"
}
